export default class SiteClient {
    constructor({ url, _get }) {
      this.url = url
      this.get = _get
    }
  
    help() {
      console.log('getSite(site_slug)')
    }
  
    async getSite(site_slug) {
      const url = `${this.url}/api/v1/sites/${site_slug}`
      return await this.get(url, null, [])
    }
}